// src/pages/warehouse/SicherungPage.tsx
// OI-130 P5 (User 2026-08-03): Sicherung als eigene Seite mit eigenem Sidebar-Punkt
// (LAGER, ganz unten). Vorher stand der Block am Fuss der Leiter-Listen und war dort
// praktisch unauffindbar. Funktional unveraendert: manueller SharePoint-Anstoss +
// ZIP-Download; die naechtliche Sicherung laeuft unabhaengig davon (n8n, 03:30).
import { toast } from 'sonner'
import { useAuth } from '@/api/auth'
import { useTriggerBackup, downloadBackupZip } from '@/api/warehouse'
import { Button } from '@/components/ui/button'

export default function SicherungPage() {
  const { warehouse } = useAuth()
  const triggerBackup = useTriggerBackup()

  if (!warehouse.admin) {
    return (
      <div className="p-8 max-w-lg mx-auto text-center space-y-2">
        <div className="text-lg font-bold text-red-700">Keine Berechtigung</div>
        <div className="text-sm text-muted">Die Sicherung ist Lager-Admins vorbehalten.</div>
      </div>
    )
  }

  return (
    <div className="p-4 max-w-2xl mx-auto space-y-4">
      <h1 className="text-xl font-bold">Sicherung</h1>
      <div className="rounded-xl border border-line bg-panel p-4 space-y-3">
        <p className="text-sm text-muted">
          Die nächtliche Sicherung läuft automatisch um 03:30 nach SharePoint
          (Ordner WAREHOUSE_BACKUPS) · Aufbewahrung 30 Tage, Monatsstände 12 Monate.
          Hier lässt sich zusätzlich jederzeit manuell sichern.
        </p>
        <div className="flex gap-2 flex-wrap">
          <Button onClick={() => triggerBackup.mutate()} disabled={triggerBackup.isPending}>
            {triggerBackup.isPending ? 'Wird angestoßen…' : 'Jetzt sichern (SharePoint)'}
          </Button>
          <Button variant="outline"
            onClick={() => void downloadBackupZip().catch((e) => toast.error(e instanceof Error ? e.message : String(e)))}>
            ZIP herunterladen
          </Button>
        </div>
      </div>
    </div>
  )
}
